module.exports = __webpack_public_path__ + "img/derecha.bc168b4e.svg";